import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';
import { GoogleConfigService } from 'src/app/private/services/googleConfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-google-config',
  imports: [SharedModule, DatePickerModule],
  templateUrl: './create-google-config.component.html',
  styleUrl: './create-google-config.component.scss'
})
export class CreateGoogleConfigComponent {

   @Input() type: 'Create' | 'Update' = 'Create';
  @Input() googleConfigDataToEdit: any = null;
  @Input() clientId: string = '';
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  isLoading = false;
  submitted = false;
  googleConfigForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private googleConfigService: GoogleConfigService,
    private messageService: MessageService
  ) {
    this.googleConfigForm = this.fb.group({
      email_id: ['', [Validators.required, Validators.email]],
      date: [new Date()],
      token_info: this.fb.group({
        access_token: ['', Validators.required],
        refresh_token: ['', Validators.required],
        token_type: ['', Validators.required],
        scope: ['', Validators.required],
        expiry_date: [null],
        id_token: ['']
      }),
      google_credential_info: this.fb.group({
        CLIENT_ID: ['', Validators.required],
        CLIENT_SECRET: ['', Validators.required],
        REDIRECT_URI: ['', Validators.required]
      })
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.googleConfigDataToEdit) {
      this.googleConfigForm.patchValue(this.googleConfigDataToEdit);

      // expiry_date is a 2025-07-22T18:30:00.000Z"
      this.googleConfigForm.patchValue({
        expiry_date: this.googleConfigDataToEdit.token_info.expiry_date ? new Date(this.googleConfigDataToEdit.token_info.expiry_date) : null
      });
      console.log('Google Config Data to Edit:', this.googleConfigDataToEdit);
    }
  }

  handleCloseDialog() {
    this.close.emit();
  }

  submitForm() {
    this.submitted = true;
    if (this.googleConfigForm.invalid) {
      this.googleConfigForm.markAllAsTouched();
      return;
    }

    const payload = {
      ...this.googleConfigForm.value,
      client_id: this.clientId
    };

    this.isLoading = true;

    if (this.type === 'Update') {
      payload['id'] = this.googleConfigDataToEdit.id;
      this.googleConfigService.updateGoogleConfig(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Configuration updated successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Update failed!' });
        },
        complete: () => this.isLoading = false
      });
    } else {
      this.googleConfigService.createGoogleConfig(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Configuration created successfully!' });
          this.isLoading = false;
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Create failed!' });
        },
        complete: () => this.isLoading = false
      });
    }
  }

}


